import {Modal, Radio} from '@mantine/core';
import {useEffect, useState} from 'react';
import type React from 'react';
import {MANAGEMENT_OVERALL_STATUS_OPTIONS} from '../../../../../../core/entities/entryManagements/constants';
import {Z_INDEX} from '../../../../constants/zIndex';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';

type Props = {
  opened: boolean;
  onClose: () => void;
  currentStatus: string;
  onUpdateStatus: (status: string) => Promise<void>;
};

/**
 * overallStatus更新を促すモーダル
 */
export const OverallStatusUpdateModal: React.FC<Props> = ({
  opened,
  onClose,
  currentStatus,
  onUpdateStatus,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(currentStatus);
  const [isUpdating, setIsUpdating] = useState(false);

  // モーダルが開かれたときにcurrentStatusで状態を同期
  useEffect(() => {
    if (opened) {
      setSelectedStatus(currentStatus);
    }
  }, [opened, currentStatus]);

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      await onUpdateStatus(selectedStatus);
      onClose();
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="企業の選考ステータスを更新しましょう！"
      size="md"
      centered
      zIndex={Z_INDEX.MODAL}
    >
      <div className="flex flex-col gap-24 p-16">
        <p className="text-base text-text-2">
          選考予定の結果が入力されました。選考結果を選択して企業の選考ステータスを更新してください。
        </p>

        <Radio.Group
          value={selectedStatus}
          onChange={setSelectedStatus}
          label="企業の選考ステータス"
          className="flex flex-col gap-8"
        >
          {MANAGEMENT_OVERALL_STATUS_OPTIONS.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              label={option.label}
            />
          ))}
        </Radio.Group>

        <div className="flex gap-8 justify-center mt-8">
          <ModalCancelButton onClick={onClose}>後で</ModalCancelButton>
          <ModalSubmitButton onClick={handleUpdate} disabled={isUpdating}>
            {isUpdating ? '更新中...' : '更新する'}
          </ModalSubmitButton>
        </div>
      </div>
    </Modal>
  );
};
